import { render, staticRenderFns } from "./ListTableClaim.vue?vue&type=template&id=eeba35f2&scoped=true&"
import script from "./ListTableClaim.vue?vue&type=script&lang=js&"
export * from "./ListTableClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeba35f2",
  null
  
)

export default component.exports